import { getTemplate } from "../template-helper";

const COMPONENT_NAME = "z-menu" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class MenuComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback(){
                this.init() ;
            }

            init(){
                if(!this.innerHTML){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                }
            }
        }
        customElements.define(COMPONENT_NAME, MenuComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
